// Provider Performance Module (Module M — BillingV2 Stage 2)
// PCP scorecards with internal peer comparison.

import ProviderPerformancePage from "./pages/ProviderPerformancePage";

// Export routes for AppRouter
export const providerPerformanceRoutes = [
  {
    path: "/provider-performance",
    element: <ProviderPerformancePage />,
  },
];

// Export components for external use
export { default as ProviderPerformancePage } from "./pages/ProviderPerformancePage";
